module.exports = __webpack_public_path__ + "static/media/20180810_172540.8e57a384.jpg";